import { DateTime } from 'luxon';

/**
 * Formats a credit-usage last-activity timestamp for display, in the viewer's
 * local zone (e.g. "June 24, 2026  2:12 PM EDT"). Returns "--" for missing or
 * invalid values.
 */
export function formatCreditActivity(value: string | null | undefined) {
  if (!value) return '--';
  const dt = DateTime.fromISO(value).toLocal();
  return dt.isValid ? dt.toFormat('MMMM d, yyyy  h:mm a ZZZZ') : '--';
}
